import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCanalAccess, selectModuleAccess } from '../store/preferencesSlice';
import { getCurrentUser } from '../services/auth';
import { useSubscription } from '../contexts/SubscriptionContext';

const ProtectedRoute = ({ children, requiredModule, requiredCanal, requiredUserFlag }) => {
  const { hasModule } = useSubscription();

  const legacyModuleAccess = useSelector((state) =>
    requiredModule ? selectModuleAccess(state, requiredModule) : true
  );
  
  const hasCanalAccess = useSelector((state) => 
    requiredCanal ? selectCanalAccess(state, requiredCanal) : true
  );

  // Check if user is authenticated
  const currentUser = getCurrentUser();
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If `requiredModule` exists in legacy Redux toggles (cdp/marketing/fidelite),
  // keep old behavior. Otherwise, use subscription modules from backend.
  const hasModuleAccess = requiredModule
    ? (legacyModuleAccess !== undefined ? legacyModuleAccess : hasModule(requiredModule))
    : true;

  // Optional user-level flag gate (e.g., loyalty_enabled)
  const hasUserFlagAccess = requiredUserFlag ? !!currentUser?.[requiredUserFlag] : true;

  // Check module and canal access
  if (!hasModuleAccess || !hasCanalAccess || !hasUserFlagAccess) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default ProtectedRoute;